<template>
  <div class="pin-native-field" @click="focus">
    <input
      ref="inputEl"
      type="tel"
      inputmode="numeric"
      pattern="[0-9]*"
      maxlength="4"
      autocomplete="off"
      autocorrect="off"
      spellcheck="false"
      class="pin-native-field__input"
      :value="modelValue"
      :aria-label="ariaLabel"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
    />
    <div class="pin-display-row" aria-hidden="true">
      <div
        v-for="i in 4"
        :key="i"
        class="pin-box"
        :class="{
          'pin-box--filled': Boolean(digits[i - 1]),
          'pin-box--active': isFocused && activeIndex === i - 1,
        }"
      >
        <span v-if="digits[i - 1]" class="pin-dot">•</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PinNativeInput',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      default: 'PIN',
    },
  },
  emits: ['update:modelValue', 'focus'],
  data() {
    return {
      isFocused: false,
    };
  },
  computed: {
    digits() {
      return this.modelValue.split('');
    },
    activeIndex() {
      return Math.min(this.digits.length, 3);
    },
  },
  methods: {
    focus() {
      this.$refs.inputEl?.focus();
    },
    onFocus() {
      this.isFocused = true;
      this.$emit('focus');
    },
    onBlur() {
      this.isFocused = false;
    },
    onInput(event) {
      const digits = event.target.value.replace(/\D/g, '').slice(0, 4);
      event.target.value = digits;
      this.$emit('update:modelValue', digits);
    },
  },
};
</script>

<style lang="scss" scoped>
.pin-native-field {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
  cursor: text;
}

.pin-native-field__input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: none;
  background: transparent;
  caret-color: transparent;
  color: transparent;
  font-size: 16px;
}

.pin-display-row {
  display: flex;
  gap: 12px;
  justify-content: flex-start;
  width: 100%;
}

.pin-box {
  width: 52px;
  height: 52px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #ddd;
  background: #f8f9fb;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.pin-box--active {
  border-color: #1a73e8;
  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);
}

.pin-dot {
  color: #111;
  font-size: 28px;
  line-height: 1;
}
</style>
